import { render, staticRenderFns } from "./StockOpnameDetails_Details.vue?vue&type=template&id=c9e7a3e0&"
import script from "./StockOpnameDetails_Details.vue?vue&type=script&lang=js&"
export * from "./StockOpnameDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports